import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-50">
            电影<span className="text-primary-500">分类</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-400">选择你喜欢的电影类型，发现更多精彩</p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {movieCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 border border-background-200 rounded-lg p-5 hover:border-primary-500/50 hover:bg-background-100/80 transition-all duration-300 cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-500 mb-3 group-hover:bg-primary-500 group-hover:text-foreground-50 transition-all duration-300">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-100 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.count} 部影片</p>
              <p className="text-xs text-foreground-400 mt-2 leading-relaxed line-clamp-2">{cat.description}</p>
              <div className="absolute bottom-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-line text-primary-500"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}